import { ImageCropper } from 'sma.common/components/image_uploader';
import * as Backbone from 'backbone';

const ajax = require('sma.common/ajax');
const modals = require('sma.common/components/modals');
const logoTempl = require('sma.applicant/organizations/partials/logo.mustache');

class OrganizationProfileView extends Backbone.View {
	get events() {
		return {
			'click .sma-js-transfer-primary': 'openTransferModal',
			'click .sma-js-remove-logo': 'removeLogo',
		};
	}

	constructor(config) {
		super();
		this.setElement($('#sma-js-org-profile'));

		this.deletionInfo = config.deletionInfo;
		this.gdpr_delay = parseInt(config.gdpr_delay);

		this.initializeLogo(config.logo);

		$.get(reverse('org-sites-data'), (response) => {
			this.sites = response.results;
		});
	}

	openTransferModal() {
		let transferModal = new modals.AjaxFormModal({
			size: 'md',
			destroyOnClose: true,
			autoShow: true,
			onSuccess: (response) => {
				transferModal.hide();
				window.location.href = response.redirect;
			},
		});

		let transferContent = new modals.AjaxFormContent(reverse('org-profile-transfer'), {
			buttons: [
				{
					label: gettext('CANCEL'),
					cls: 'btn-secondary',
					handler: (modal) => {
						modal.hide();
					},
				},
				{
					label: gettext('TRANSFER'),
					cls: 'btn-primary',
					handler: (modal) => {
						modal.modalBody.find('form').submit();
					},
				},
			],
		});

		transferModal.addToStack('Main', transferContent);
	}

	initializeLogo(logo) {
		this.setLogo({
			remove_photo: gettext('Remove photo'),
			logo: logo,
		});

		let imageUploaderConfig = {
			wrapper: $('#org-logo-container'),
			inputField: '.sma-js-img-upload-field',
			onCropHandler: (croppedImg) => {
				this.setLogo({
					remove_photo: gettext('Remove photo'),
					logo: croppedImg,
				});
				$('#sma-hidden-profile-img').val(croppedImg);
				this.saveLogo();
			},
		};

		new ImageCropper(imageUploaderConfig);
	}

	saveLogo() {
		ajax.post({
			url: reverse('org-profile-logo'),
			data: new FormData($('#sma-org-logo-form')[0]),
			cache: false,
			datatype: 'json',
			processData: false,
			contentType: false,
		});
	}

	removeLogo(e) {
		ajax.post({
			url: reverse('org-profile-logo-remove'),
			callback: (result) => {
				this.setLogo({});
			},
		});
	}

	setLogo(data) {
		$('#org-logo-container').html(logoTempl(data));
		window.localize(); // To translate the file widget
	}
}

module.exports = {
	OrganizationProfileView,
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/organizations/profile.js